"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _reduxObservable = require("redux-observable");

var _operators = require("rxjs/operators");

var _services = require("@alycecom/services");

var actions = _interopRequireWildcard(require("./personalProfileSettings.actions"));

var helpers = _interopRequireWildcard(require("./personalProfileSettings.helpers"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2.default)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var transformErrors = function transformErrors(error) {
  return _objectSpread(_objectSpread({}, error), {}, {
    errors: (0, helpers.transformProfileSettingsResponseToErrors)(error && error.errors || error)
  });
};

var getSettingsEpic = function getSettingsEpic(action$, state$, _ref) {
  var personalSettingsService = _ref.personalSettingsService,
      errorHandler = _ref.messagesService.errorHandler;
  return action$.pipe((0, _reduxObservable.ofType)(actions.getSettings), (0, _operators.mergeMap)(function () {
    return personalSettingsService.getProfileSettings().pipe((0, _operators.mergeMap)(function (response) {
      return [actions.getSettingsSuccess(helpers.transformGetSettingsResponseToPayload(response.settings))];
    }), (0, _operators.catchError)(errorHandler({
      callbacks: actions.getSettingsFail
    })), (0, _operators.takeUntil)(action$.ofType(actions.getSettings)));
  }));
};

var setPasswordEpic = function setPasswordEpic(action$, state$, _ref2) {
  var personalSettingsService = _ref2.personalSettingsService,
      _ref2$messagesService = _ref2.messagesService,
      errorHandler = _ref2$messagesService.errorHandler,
      showGlobalMessage = _ref2$messagesService.showGlobalMessage;
  return action$.pipe((0, _reduxObservable.ofType)(actions.setPassword), (0, _operators.mergeMap)(function (_ref3) {
    var _ref3$meta = _ref3.meta,
        currentPassword = _ref3$meta.currentPassword,
        newPassword = _ref3$meta.newPassword,
        newPasswordConfirmation = _ref3$meta.newPasswordConfirmation;
    return personalSettingsService.setPassword({
      currentPassword,
      newPassword,
      newPasswordConfirmation
    }).pipe((0, _operators.mergeMap)(function () {
      return [actions.setPasswordSuccess(), showGlobalMessage({
        text: 'Password changed',
        type: 'success'
      })];
    }), (0, _operators.catchError)(function (error) {
      var errors = error.errors;
      var isForcedSSOError = errors && Array.isArray(errors) && errors.includes('validation_error');

      var modifiedError = _objectSpread(_objectSpread({}, error), {}, {
        message: isForcedSSOError && 'Organization has Forced SSO enabled. Password changing is disabled'
      });

      return errorHandler({
        callbacks: actions.setPasswordFail,
        showErrorsAsGlobal: true
      })(transformErrors(modifiedError));
    }), (0, _operators.takeUntil)(action$.ofType(actions.setPassword)));
  }));
};

var resetPasswordEpic = function resetPasswordEpic(action$, state$, _ref4) {
  var personalSettingsService = _ref4.personalSettingsService,
      _ref4$messagesService = _ref4.messagesService,
      errorHandler = _ref4$messagesService.errorHandler,
      showGlobalMessage = _ref4$messagesService.showGlobalMessage;
  return action$.pipe((0, _reduxObservable.ofType)(actions.resetPassword), (0, _operators.mergeMap)(function () {
    return personalSettingsService.resetPassword().pipe((0, _operators.mergeMap)(function () {
      return [actions.resetPasswordSuccess(), showGlobalMessage({
        text: 'Password was successfully reset. Link sent to your email.',
        type: 'success'
      })];
    }), (0, _operators.catchError)(errorHandler({
      callbacks: actions.resetPasswordFail,
      showErrorsAsGlobal: true
    })), (0, _operators.takeUntil)(action$.ofType(actions.resetPassword)));
  }));
};

var setCurrencyEpic = function setCurrencyEpic(action$, state$, _ref5) {
  var personalSettingsService = _ref5.personalSettingsService,
      _ref5$messagesService = _ref5.messagesService,
      errorHandler = _ref5$messagesService.errorHandler,
      showGlobalMessage = _ref5$messagesService.showGlobalMessage;
  return action$.pipe((0, _reduxObservable.ofType)(actions.setCurrency), (0, _operators.mergeMap)(function (_ref6) {
    var currencyId = _ref6.payload;
    return personalSettingsService.setCurrency(currencyId).pipe((0, _operators.mergeMap)(function () {
      return [actions.setCurrencySuccess(currencyId), showGlobalMessage({
        text: 'Changes saved',
        type: 'success'
      })];
    }), (0, _operators.catchError)(errorHandler({
      callbacks: actions.setCurrencyFail
    })), (0, _operators.takeUntil)(action$.ofType(actions.setCurrency)));
  }));
};

var setCountryEpic = function setCountryEpic(action$, state$, _ref7) {
  var personalSettingsService = _ref7.personalSettingsService,
      _ref7$messagesService = _ref7.messagesService,
      errorHandler = _ref7$messagesService.errorHandler,
      showGlobalMessage = _ref7$messagesService.showGlobalMessage;
  return action$.pipe((0, _reduxObservable.ofType)(actions.setCountry), (0, _operators.mergeMap)(function (_ref8) {
    var countryId = _ref8.payload;
    return personalSettingsService.setCountry(countryId).pipe((0, _operators.mergeMap)(function () {
      return [actions.setCountrySuccess(countryId), showGlobalMessage({
        text: 'Changes saved',
        type: 'success'
      })];
    }), (0, _operators.catchError)(errorHandler({
      callbacks: actions.setCountryFail
    })), (0, _operators.takeUntil)(action$.ofType(actions.setCountry)));
  }));
};

var unsubscribeEpic = function unsubscribeEpic(action$, state$, _ref9) {
  var personalSettingsService = _ref9.personalSettingsService,
      _ref9$messagesService = _ref9.messagesService,
      errorHandler = _ref9$messagesService.errorHandler,
      showGlobalMessage = _ref9$messagesService.showGlobalMessage;
  return action$.pipe((0, _reduxObservable.ofType)(actions.unsubscribe), (0, _operators.mergeMap)(function () {
    return personalSettingsService.unsubscribe().pipe((0, _operators.mergeMap)(function () {
      return [actions.unsubscribeSuccess(), showGlobalMessage({
        text: 'Changes saved',
        type: 'success'
      })];
    }), (0, _operators.catchError)(errorHandler({
      callbacks: actions.unsubscribeFail
    })), (0, _operators.takeUntil)(action$.ofType(actions.unsubscribe)));
  }));
};

var setMeetingPreferencesEpic = function setMeetingPreferencesEpic(action$, state$, _ref10) {
  var personalSettingsService = _ref10.personalSettingsService,
      apiService = _ref10.apiService,
      showGlobalMessage = _ref10.messagesService.showGlobalMessage;
  return action$.pipe((0, _reduxObservable.ofType)(actions.setMeetingsPreferences), (0, _operators.switchMap)(function (_ref11) {
    var meetingPreferences = _ref11.payload;
    return personalSettingsService.setMeetingPreferences(meetingPreferences).pipe((0, _operators.mergeMap)(function () {
      return [actions.setMeetingPreferencesSuccess(meetingPreferences), showGlobalMessage({
        text: 'Changes saved',
        type: 'success'
      })];
    }), (0, _operators.catchError)(apiService.handleError(_services.handlers.handleLegacyAnyError(function (error) {
      return actions.setMeetingPreferencesFail((0, helpers.transformMeetingSettingsErrors)(error));
    }))));
  }));
};

var setCalendarPeriodEpic = function setCalendarPeriodEpic(action$, state$, _ref12) {
  var personalSettingsService = _ref12.personalSettingsService,
      _ref12$messagesServic = _ref12.messagesService,
      errorHandler = _ref12$messagesServic.errorHandler,
      showGlobalMessage = _ref12$messagesServic.showGlobalMessage;
  return action$.pipe((0, _reduxObservable.ofType)(actions.setCalendarPeriod), (0, _operators.mergeMap)(function (_ref13) {
    var calendarPeriods = _ref13.payload;
    return personalSettingsService.setCalendarPeriod((0, helpers.transformAvailablePeriodsToRequest)(calendarPeriods)).pipe((0, _operators.mergeMap)(function () {
      return [actions.setCalendarPeriodSuccess(calendarPeriods), showGlobalMessage({
        text: 'Changes saved',
        type: 'success'
      })];
    }), (0, _operators.catchError)(function (response) {
      var error = transformErrors(response);
      var errors = error.errors;
      var text = errors.calendarPeriods && errors.calendarPeriods.message || error;
      return errorHandler({
        callbacks: [actions.setCalendarPeriodFail, function () {
          return showGlobalMessage({
            type: 'error',
            text
          });
        }]
      })(error);
    }), (0, _operators.takeUntil)(action$.ofType(actions.setCalendarPeriod)));
  }));
};

var personalProfileSettingsEpics = [getSettingsEpic, setPasswordEpic, resetPasswordEpic, setCountryEpic, setCurrencyEpic, setCalendarPeriodEpic, setMeetingPreferencesEpic, unsubscribeEpic];
var _default = personalProfileSettingsEpics;
exports.default = _default;